

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/test/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/7.cWYTNNFe.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/DcKRL2at.js","_app/immutable/chunks/CrkJ0M0_.js","_app/immutable/chunks/C1FmrZbK.js","_app/immutable/chunks/CFMktExA.js"];
export const stylesheets = ["_app/immutable/assets/Editor.DleZyqak.css"];
export const fonts = [];
